// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"797abb00","239":"d635f6f2","455":"077bd0cb"}[chunkId] + ".chunk.js";
};